import { CombinedGraphQLErrors } from '@apollo/client';

import { useSnackbar } from 'common/hooks/useSnackbar';
import { getErrorMessage } from 'common/utils/getErrorMessage';

/**
 * Hook to display snackbar messages for Apollo errors
 */
export const useApolloError = () => {
    const [displaySnackbar] = useSnackbar();

    // By default the error is unknown so we accept unknown here and cast it to
    // ApolloError
    const showApolloError = (error: unknown) => {
        if (CombinedGraphQLErrors.is(error)) {
            error.errors.forEach((e) => {
                const errorMessage = getErrorMessage(e);

                if (errorMessage) {
                    displaySnackbar(errorMessage);
                }
            });
        }
    };

    return { showApolloError };
};
